import React from "react";
import SoftBox from "components/SoftBox";
import SoftModal from "components/SoftModal";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { registerUser } from "http/authApi";
import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";

const UserCreate = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const queryClient = useQueryClient()

  const { mutate, isError } = useMutation((formData) => registerUser(formData), {
    onSuccess: (response, formData) => {
      queryClient.invalidateQueries('realusers');
      setOpen(false);
    },
    onError: (error) => {
      console.log(error);
      // setError(error.response.data.message);
    },
  });

  const submitHandler = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    const user = { email: email, password: password };

    await mutate(user);
  };

  return (
    <SoftBox>
      <SoftButton variant="outlined" color="warning" onClick={handleOpen}>
        {t("modal.add_user")}
      </SoftButton>
      <SoftModal title={t("modal.edit_user")} open={open} handleClose={handleClose}>
        <SoftBox component="form" role="form" onSubmit={submitHandler}>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                {t("modal.email")}
              </SoftTypography>
            </SoftBox>
            <SoftInput type="email" required placeholder={t("modal.email")} id="email" name="email" />
          </SoftBox>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                id="password"
                name="password"
              >
                {t("modal.password")}
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type={showPassword ? "text" : "password"}
              placeholder={t("modal.password")}
              id="password"
              name="password"
              required
              icon={{
                component: showPassword ? (
                  <Visibility
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={() => setShowPassword(!showPassword)}
                  />
                ) : (
                  <VisibilityOff
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={() => setShowPassword(!showPassword)}
                  />
                ),
                direction: "right",
              }}
            />
          </SoftBox>
          <SoftBox mt={4} mb={1}>
            <SoftButton type="submit" variant="gradient" color="warning">
              {t("modal.create")}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftModal>
    </SoftBox>
  );
};

export default UserCreate;
